import React from "react";
import Seo from "@/components/Seo";
import Calculator from "@/components/Calculator";
import CtaStrip from "@/components/CtaStrip";

export default function CalculatorPage() {
    return (
        <div data-testid="page-calculator" className="pt-20">
            <Seo
                title="Mortgage Repayment Calculator | Finance Wealth Australia"
                description="Estimate your monthly home loan repayments. Adjust loan amount, interest rate and term. Then chat with Australia-wide mortgage broker Gurpreet Singh for a real rate from 60+ lenders."
                keywords="mortgage calculator, home loan calculator Australia, repayment calculator, interest calculator Australia"
            />
            <section className="bg-[#F3F1EA]">
                <div className="container-prose py-20 md:py-28">
                    <div className="max-w-3xl">
                        <div className="overline">Tools</div>
                        <h1 className="mt-4 font-serif text-5xl sm:text-6xl tracking-tight leading-[1.02] text-[#1A362B] font-medium">
                            Repayment calculator.
                        </h1>
                        <div className="divider-thin my-8" />
                        <p className="text-lg text-[#1C1C1C]/75 leading-relaxed font-light">
                            Get a quick estimate of what your home loan repayments could look like — then book a
                            chat to see the real rates we can secure for you.
                        </p>
                    </div>
                </div>
            </section>
            <Calculator />
            <CtaStrip />
        </div>
    );
}
